import React, { useState, useRef } from 'react'
import emailjs from 'emailjs-com'

import Backgrd from '../asset/images/hero-bg.jpg'
import { H2Form } from '../common/H2/H2'
import {
	SectionForm,
	DivContainer,
	ContainerDiv,
	FormContainer,
	FieldsContainer,
	Label,
	Input,
	TextArea,
	CheckboxLabel,
	CheckboxInput,
	Button,
} from '../common/Form/Form'
import {
	PopupContainer,
	PopupContent,
	PopupButton,
} from '../common/PopUp/Popup'

import inscription from '../asset/images/inscription.jpg'

const service_id = process.env.REACT_APP_YOUR_SERVICE_ID
const template_id = process.env.REACT_APP_YOUR_TEMPLATE_ID
const user_id = process.env.REACT_APP_YOUR_USER_ID

function Formulaire() {
	const [parentLastName, setParentLastName] = useState('')
	const [parentPhone, setParentPhone] = useState('')
	const [parentEmail, setParentEmail] = useState('')
	const [parentAdresse, setParentAdresse] = useState('')
	const [childLastName, setChildLastName] = useState('')
	const [childFirstName, setChildFirstName] = useState('')
	const [childActualClass, setChildActualClass] = useState('')
	const [selectedSubjects, setSelectedSubjects] = useState([])
	const [selectedSubjectsOther, setSelectedSubjectsOther] = useState('')
	const [selectedTypes, setSelectedTypes] = useState([])
	const [selectedDispo, setSelectedDispo] = useState([])
	const [nbrcours, setNbrcours] = useState('')
	const [comment, setComment] = useState('')
	const [showPopup, setShowPopup] = useState(false)
	const [showPopupSuccess, setShowPopupSuccess] = useState(false)
	const form = useRef()

	const subjects = [
		'Eveil',
		'Français',
		'Mathématiques',
		'Anglais',
		'Etude',
		'Stage',
	]

	const types = [
		'Remise à niveau',
		'Révision',
		"Anticiper / s'avancer",
		'Encadrement',
	]

	const disponibilites = [
		"Lundi fin d'après-midi",
		"Mardi fin d'après-midi",
		'Mercredi matin',
		'Mercredi après-midi',
		"Jeudi fin d'après-midi",
		"Vendredi fin d'après-midi",
		'Samedi matin',
		'Samedi après-midi',
	]

	const showMissingFieldsPopup = () => {
		setShowPopup(true)
	}

	const handleSubmit = (e) => {
		e.preventDefault()

		const isSubjectsEmpty = selectedSubjects.length === 0
		const isTypesEmpty = selectedTypes.length === 0
		const isDispoEmpty = selectedDispo.length === 0

		if (
			parentLastName &&
			parentEmail &&
			parentPhone &&
			parentAdresse &&
			childLastName &&
			childFirstName &&
			childActualClass &&
			nbrcours >= 0 &&
			!isSubjectsEmpty &&
			!isTypesEmpty &&
			!isDispoEmpty
		) {
			const mess = {
				Nom_parent: parentLastName,
				Email_parent: parentEmail,
				Phone_parent: parentPhone,
				Adresse_parent: parentAdresse,
				Nom_enfant: childLastName,
				Prenom_enfant: childFirstName,
				Classe_enfant: childActualClass,

				Selected_Subjects: selectedSubjects,
				Selected_Subjects_Other: selectedSubjectsOther,
				Selected_Types: selectedTypes,
				Nbr_cours_études: nbrcours,
				Disponibilite: selectedDispo,
				Comment: comment,
			}

			emailjs
				.sendForm(service_id, template_id, form.current, user_id, mess)
				.then(
					function (response) {
						console.log('SUCCESS!', response.status, response.text, mess)
						setShowPopupSuccess(true)
					},
					function (error) {
						console.log('FAILED...', error)
					},
				)
		} else {
			showMissingFieldsPopup()
		}
	}

	return (
		<SectionForm style={{ backgroundImage: `url(${Backgrd})` }}>
			<H2Form>Formulaire d'inscription</H2Form>
			<ContainerDiv>
				<DivContainer>
					<img
						src={inscription}
						width="450"
						height="590"
						alt="inscription"
						className="w-100 form-img"
					/>
				</DivContainer>

				<FormContainer>
					<form ref={form} onSubmit={handleSubmit}>
						<FieldsContainer>
							<Label htmlFor="parentLastName">Nom parent :</Label>
							<Input
								required
								type="text"
								id="parentLastName"
								name="parentLastName"
								value={parentLastName}
								onChange={(e) => setParentLastName(e.target.value)}
							/>

							<Label htmlFor="parentPhone">Téléphone :</Label>
							<Input
								required
								type="tel"
								id="parentPhone"
								name="parentPhone"
								value={parentPhone}
								onChange={(e) => setParentPhone(e.target.value)}
							/>

							<Label htmlFor="parentEmail">Email :</Label>
							<Input
								required
								type="email"
								id="parentEmail"
								name="parentEmail"
								value={parentEmail}
								onChange={(e) => setParentEmail(e.target.value)}
							/>

							<Label htmlFor="parentAdresse">Adresse :</Label>
							<Input
								required
								type="text"
								id="parentAdresse"
								name="parentAdresse"
								value={parentAdresse}
								onChange={(e) => setParentAdresse(e.target.value)}
							/>
						</FieldsContainer>

						<FieldsContainer>
							<Label htmlFor="childLastName">Nom enfant :</Label>
							<Input
								required
								type="text"
								id="childLastName"
								name="childLastName"
								value={childLastName}
								onChange={(e) => setChildLastName(e.target.value)}
							/>

							<Label htmlFor="childFirstName">Prénom enfant :</Label>
							<Input
								required
								type="text"
								id="childFirstName"
								name="childFirstName"
								value={childFirstName}
								onChange={(e) => setChildFirstName(e.target.value)}
							/>

							<Label htmlFor="childActualClass">Classe actuelle :</Label>
							<Input
								required
								type="text"
								id="childActualClass"
								name="childActualClass"
								value={childActualClass}
								onChange={(e) => setChildActualClass(e.target.value)}
							/>
						</FieldsContainer>

						<FieldsContainer
							style={{
								display: 'flex',
								flexDirection: 'row',
								flexWrap: 'wrap',
								justifyContent: 'left',
							}}
						>
							<Label>Suivi recherché:</Label>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									flexWrap: 'wrap',
									justifyContent: 'left',
									width: '60%',
								}}
							>
								{subjects.map((subject) => (
									<CheckboxLabel key={subject}>
										<CheckboxInput
											type="checkbox"
											value={subject}
											id="selectedSubjects"
											name="selectedSubjects"
											checked={selectedSubjects.includes(subject)}
											onChange={(e) => {
												if (e.target.checked) {
													setSelectedSubjects([...selectedSubjects, subject])
												} else {
													setSelectedSubjects(
														selectedSubjects.filter((t) => t !== subject),
													)
												}
											}}
										/>
										{subject}
									</CheckboxLabel>
								))}
							</div>
						</FieldsContainer>

						<FieldsContainer
							style={{
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'left',
								marginBlockEnd: '20px',
							}}
						>
							<Label htmlFor="selectedSubjectsOther">Autre :</Label>
							<Input
								style={{ width: '77%', marginLeft: '10px' }}
								type="text"
								id="selectedSubjectsOther"
								name="selectedSubjectsOther"
								value={selectedSubjectsOther}
								onChange={(e) => setSelectedSubjectsOther(e.target.value)}
							/>
						</FieldsContainer>

						<FieldsContainer
							style={{
								display: 'flex',
								flexDirection: 'row',
								flexWrap: 'wrap',
								justifyContent: 'left',
								marginBlockEnd: '20px',
							}}
						>
							<Label>Intention : </Label>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									flexWrap: 'wrap',
									justifyContent: 'left',
									width: '60%',
								}}
							>
								{types.map((type) => (
									<CheckboxLabel key={type}>
										<CheckboxInput
											type="checkbox"
											id="selectedTypes"
											name="selectedTypes"
											value={type}
											checked={selectedTypes.includes(type)}
											onChange={(e) => {
												if (e.target.checked) {
													setSelectedTypes([...selectedTypes, type])
												} else {
													setSelectedTypes(
														selectedTypes.filter((t) => t !== type),
													)
												}
											}}
										/>
										{type}
									</CheckboxLabel>
								))}
							</div>
						</FieldsContainer>

						<FieldsContainer>
							<Label htmlFor="nbrcours">
								Nombre de cours ou études souhaités :
							</Label>
							<Input
								required
								min="0"
								type="number"
								id="nbrcours"
								name="nbrcours"
								value={nbrcours}
								onChange={(e) => {
									setNbrcours(e.target.value)
								}}
							/>
						</FieldsContainer>

						<FieldsContainer
							style={{
								display: 'flex',
								flexDirection: 'row',
								flexWrap: 'wrap',
								justifyContent: 'left',
								marginBlockEnd: '20px',
							}}
						>
							<Label>Disponibilités : </Label>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									flexWrap: 'wrap',
									justifyContent: 'left',
									width: '60%',
								}}
							>
								{disponibilites.map((Disponibilite) => (
									<CheckboxLabel key={Disponibilite}>
										<CheckboxInput
											type="checkbox"
											id="selectedDispo"
											name="selectedDispo"
											value={Disponibilite}
											checked={selectedDispo.includes(Disponibilite)}
											onChange={(e) => {
												if (e.target.checked) {
													setSelectedDispo([...selectedDispo, Disponibilite])
												} else {
													setSelectedDispo(
														selectedDispo.filter((t) => t !== Disponibilite),
													)
												}
											}}
										/>
										{Disponibilite}
									</CheckboxLabel>
								))}
							</div>
						</FieldsContainer>

						<FieldsContainer>
							<Label htmlFor="comment">
								Remarque (autre besoin ou information particulière à apporter) :
							</Label>
							<TextArea
								id="comment"
								name="comment"
								value={comment}
								onChange={(e) => setComment(e.target.value)}
							/>
						</FieldsContainer>
						<Button type="submit" className="btn-primary">
							<span className="span">Envoyer</span>
							<ion-icon
								name="arrow-forward-outline"
								aria-hidden="true"
							></ion-icon>
						</Button>

						{showPopup && (
							<PopupContainer>
								<PopupContent>
									Veuillez remplir tous les champs obligatoires.
								</PopupContent>
								<PopupButton onClick={() => setShowPopup(false)}>
									OK
								</PopupButton>
							</PopupContainer>
						)}

						{showPopupSuccess && (
							<PopupContainer>
								<PopupContent>
									Votre demande d'inscription a été envoyé
								</PopupContent>
								<PopupButton onClick={() => setShowPopupSuccess(false)}>
									OK
								</PopupButton>
							</PopupContainer>
						)}
					</form>
				</FormContainer>
			</ContainerDiv>
		</SectionForm>
	)
}

export default Formulaire
